import { render, staticRenderFns } from "./FollowingList.vue?vue&type=template&id=5cfe2fb8&scoped=true"
import script from "./FollowingList.vue?vue&type=script&lang=js"
export * from "./FollowingList.vue?vue&type=script&lang=js"
import style0 from "./FollowingList.vue?vue&type=style&index=0&id=5cfe2fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfe2fb8",
  null
  
)

export default component.exports